







































































































import { computed, defineComponent, getCurrentInstance, onMounted, ref } from "vue";
import { formatLongDate, readBoaHora, BoaHoraAppointment } from "@/utils/programaBoaHora";

export default defineComponent({
  setup() {
    const context = getCurrentInstance().proxy;
    const appointment = ref<BoaHoraAppointment | null>(null);
    const longDate = computed(() => formatLongDate(appointment.value?.isoDate));

    onMounted(() => {
      context.$root.$emit("hide-loading");
      const record = readBoaHora(context.$store.state.saude.vinculo);
      if (!record.appointment) {
        context.$router.replace({ name: "programa_saude_2.boa_hora.acompanhamento" });
        return;
      }
      appointment.value = record.appointment;
    });

    const reschedule = () => {
      context.$router.push({ name: "programa_saude_2.boa_hora.agendamento" });
    };

    return { appointment, longDate, reschedule };
  }
});
